import {IncomingHttpHeaders} from 'http';
import {createContext, useContext} from 'react';

export const DEFAULT_CONTENTFUL_ENV = 'master';

export interface ContentfulConfig {
  isPreview: boolean;
  spaceId: string;
  environment: string;
}

const Context = createContext<ContentfulConfig>({
  isPreview: false,
  spaceId: '',
  environment: DEFAULT_CONTENTFUL_ENV,
});

export function useContentfulConfig() {
  return useContext(Context);
}

export const ContentfulContextProvider = Context.Provider;

export function getContentfulConfig(
  headers?: IncomingHttpHeaders,
): ContentfulConfig {
  return {
    spaceId: headers?.['x-contentful-space']?.toString() || '',
    environment:
      headers?.['x-contentful-env']?.toString() || DEFAULT_CONTENTFUL_ENV,
    isPreview: !!headers?.['x-contentful-preview-mode'],
  };
}
